import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SiCardModule } from '@siemens/element-ng/card';

import { ScheduleComponent } from './schedule/schedule.component';
import { TrackComponent } from './track/track.component';
@Component({
  selector: 'app-schedule-and-track',
  imports: [ScheduleComponent, TrackComponent, SiCardModule, TranslatePipe],
  templateUrl: './schedule-and-track.component.html',
  styleUrl: './schedule-and-track.component.scss'
})
export class ScheduleAndTrackComponent {}
